"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearCursorPosition = exports.setCursorPosition = exports.getCursorPosition = void 0;

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var getCursorPosition = function getCursorPosition(element) {
  if (element.isContentEditable) {
    try {
      var selection = window.getSelection();
      var range = selection.getRangeAt(0);
      var preCaretRange = range.cloneRange();
      preCaretRange.selectNodeContents(element);
      preCaretRange.setEnd(range.endContainer, range.endOffset);
      return preCaretRange.toString().length;
    } catch (err) {
      return 0;
    }
  }

  return element.selectionEnd || 0;
};

exports.getCursorPosition = getCursorPosition;

var setCursorPosition = function setCursorPosition(element, newCursorPosition) {
  if (element.isContentEditable) {
    var createRange = function createRange(node, newCharCount, newRange) {
      var curCharCount = newCharCount;
      var curRange = newRange;

      if (!curRange) {
        curRange = document.createRange();
        curRange.selectNode(node);
        curRange.setStart(node, 0);
      }

      if (curCharCount === 0) {
        curRange.setEnd(node, curCharCount);
      } else if (node && curCharCount > 0) {
        if (node.nodeType === Node.TEXT_NODE) {
          if (node.textContent.length < curCharCount) {
            curCharCount -= node.textContent.length;
          } else {
            curRange.setEnd(node, curCharCount);
            curCharCount = 0;
          }
        } else {
          Array.from(node.childNodes).some(function (childNode) {
            var updatedRange = createRange(childNode, curCharCount, curRange);
            curCharCount = updatedRange.charCount;
            curRange = updatedRange.range;
            return curCharCount === 0;
          });
        }
      }

      return {
        range: curRange,
        charCount: curCharCount
      };
    };

    var selection = window.getSelection();

    var _createRange = createRange(element, newCursorPosition),
        range = _createRange.range;

    range.collapse(false);
    selection.removeAllRanges();
    selection.addRange(range);
  } else {
    element.selectionEnd = newCursorPosition;
  }
};

exports.setCursorPosition = setCursorPosition;

var clearCursorPosition = function clearCursorPosition() {
  var selection = window.getSelection();

  if (selection.empty) {
    selection.empty();
  } else if (selection.removeAllRanges) {
    selection.removeAllRanges();
  }
};

exports.clearCursorPosition = clearCursorPosition;